import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateChildOrganization(
    $id: String!
    $data: updateChildOrganizationInput!
  ) {
    updateChildOrganization(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateChildOrganizationRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateChildOrganizationInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/update_child_organization',
  async (
  params: {id: String;data: TYPES.UpdateChildOrganizationInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateChildOrganization;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateChildOrganizationSlice = createSlice({
  name: 'update_child_organization',
  initialState: initialState,
  reducers: {
    updateChildOrganizationClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateChildOrganizationRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateChildOrganizationRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateChildOrganizationRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateChildOrganizationClear } =
updateChildOrganizationSlice.actions;

export const updateChildOrganization = createSelector(
  (state: RootState) => state.organization.updateChildOrganization.result,
  (state: RootState) => state.organization.updateChildOrganization.error,
  (state: RootState) => state.organization.updateChildOrganization.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateChildOrganizationSlice.reducer;